/* BRINUTI – fotós AI-dizájn próbálkozások naplója (2026-10-28, a tulaj kérése).

   Cél: lássuk, hányadik próbálkozásra vásárolnak (és mikor lépnek ki), és a havi áttekintésnél
   összevethessük a dizájnok eredményeit, hogy kiderüljön, melyik dizájn sikerül rosszul.

   Hogyan: a Teeinblue minden fotófeltöltésnél a photo-api.teeinblue.com
   `/customer-uploads/<azonosító>/apply-effects` címet hívja (ez futtatja az AI-hatást), a válasz
   tartalmazza a generált kép útvonalát. Ezt a hívást és a kosárba tételt (`/cart/add.js`) csak
   megfigyeljük (a válasz másolatát olvassuk), és egy kis eseményt küldünk a naplózó Workernek
   (docs/probalkozas-naplo/worker.js → D1).

   A kosárba tételnél a sor `_customization_id` azonosítóját is mentjük: ugyanez az érték van a
   Shopify-rendelés soránál, így a próbálkozások és a vásárlás összekapcsolhatók. A fotót a vevő
   több próbálkozás közül választhatja, ezért a kosárhoz a munkamenet utolsó próbálkozását
   rendeljük (közelítés).

   Amit NEM tárol: fotót, képet, IP-címet, nevet, e-mailt. Csak egy névtelen, véletlen
   munkamenet-azonosítót, a terméket, a Teeinblue feltöltés azonosítóját és a generált kép
   Teeinblue-útvonalát. A képet a Teeinblue tárolja; a havi áttekintésnél onnan nézzük meg.

   A mérés soha nem törheti el a boltot: minden hívás try/catch-ben fut, és a Teeinblue/Shopify
   kérések válaszát érintetlenül adjuk vissza. */
(function () {
  if (window.__bpNaplo) return;
  window.__bpNaplo = true;

  var VEGPONT = 'https://brinuti-probalkozas-naplo.ferraj.workers.dev/e';
  var EREDETI_FETCH = window.fetch;
  if (typeof EREDETI_FETCH !== 'function') return;

  var HATAS = /photo-api\.teeinblue\.com\/api\/merchant\/shopify\/customer-uploads\/(\d+)\/apply-effects/;
  var KOSAR = /\/cart\/add(\.js)?(\?|$)/;
  /* 2026-10-28: a Teeinblue AI-effektje (gpt/gemini/flux:image_filter) NEM az apply-effects úton megy: a feltöltés után
     a `genai-uploads` indítja, a kész képet az `image-filter-effects/status` hívás adja (status 2 = kész, >2 = hiba).
     Enélkül a Pendraw Magic (ceruzarajz) generálásait a napló nem látná. Feltöltésenként egyszer naplózunk. */
  var AI_ALLAPOT = /photo-api\.teeinblue\.com\/api\/merchant\/shopify\/customer-uploads\/(\d+)\/image-filter-effects\/status/;
  var AI_NAPLOZVA = {};

  // Névtelen, véletlen munkamenet-azonosító (nem sütit használ, csak a böngésző tárolóját).
  function azonosito() {
    var kulcs = 'bpn_sid', v = null;
    try { v = window.localStorage.getItem(kulcs); } catch (e) { /* tiltott tároló */ }
    if (v && v.length >= 16) return v;
    var b = new Uint8Array(12);
    try { window.crypto.getRandomValues(b); } catch (e) { for (var i = 0; i < b.length; i++) b[i] = Math.floor(Math.random() * 256); }
    v = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    try { window.localStorage.setItem(kulcs, v); } catch (e) { /* nincs mentés, marad az oldalbetöltésig */ }
    return v;
  }
  var SID = azonosito();

  function termek() {
    var m = /\/products\/([^/?#]+)/.exec(location.pathname);
    return m ? m[1] : null;
  }
  function kampany() {
    try { var c = window.teeinblueCampaign; return c && c.productId ? String(c.productId) : null; } catch (e) { return null; }
  }
  // A tárolóelőtagot (ws: / we:) megtartjuk: ebből tudja a Worker, melyik Teeinblue-tárolóból másolja a képet.
  function ut(s) { return s ? String(s) : null; }

  function kuld(adat) {
    try {
      adat.sid = SID;
      if (adat.h === undefined) adat.h = termek();
      if (adat.c === undefined) adat.c = kampany();
      // text/plain: nincs előzetes CORS-kérés; a Worker szövegként olvassa.
      EREDETI_FETCH.call(window, VEGPONT, {
        method: 'POST', body: JSON.stringify(adat), keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, credentials: 'omit'
      }).then(function (r) { return r.json(); }).then(function (j) {
        // A Clarity-felvételeknél is szűrhető legyen: hányadik próbálkozás volt.
        if (j && j.n && typeof window.brinutiEsemeny === 'function') {
          window.brinutiEsemeny('ai_generalas', { brinuti_ai_proba: j.n });
        }
      }).catch(function () { /* a mérés hibája nem számít */ });
    } catch (e) { /* ugyanaz */ }
  }

  function mezoAzonosito(init, bemenet) {
    try {
      var t = init && init.body;
      if (t && typeof t.get === 'function') return t.get('field_id');
    } catch (e) { /* nem űrlap */ }
    return null;
  }

  window.fetch = function (bemenet, init) {
    var cim = '';
    try { cim = typeof bemenet === 'string' ? bemenet : (bemenet && bemenet.url) || String(bemenet); } catch (e) { /* üres */ }
    var ig = EREDETI_FETCH.apply(this, arguments);
    try {
      var h = HATAS.exec(cim);
      if (h) {
        var mezo = mezoAzonosito(init, bemenet);
        ig.then(function (v) {
          try {
            if (!v.ok) { kuld({ t: 'gen_err', u: h[1], f: mezo, x: { s: v.status } }); return; }
            v.clone().json().then(function (j) {
              var hatas = j && j.effects && j.effects.effects && j.effects.effects[0];
              kuld({ t: 'gen', u: h[1], f: mezo, e: hatas && hatas.type, r: ut(j && j.url) });
            }).catch(function () { kuld({ t: 'gen', u: h[1], f: mezo }); });
          } catch (e) { /* nem baj */ }
        }, function () { kuld({ t: 'gen_err', u: h[1], f: mezo, x: { s: 0 } }); });
      } else if (AI_ALLAPOT.test(cim)) {
        var a = AI_ALLAPOT.exec(cim);
        ig.then(function (v) {
          try {
            if (AI_NAPLOZVA[a[1]]) return;
            if (!v.ok) { AI_NAPLOZVA[a[1]] = 1; kuld({ t: 'gen_err', u: a[1], f: null, x: { s: v.status, ai: 1 } }); return; }
            v.clone().json().then(function (j) {
              if (!j || AI_NAPLOZVA[a[1]]) return;
              var hatas = j.effects && j.effects.effects && j.effects.effects[0];
              if (j.status === 2) { AI_NAPLOZVA[a[1]] = 1; kuld({ t: 'gen', u: a[1], f: null, e: hatas && hatas.type, r: ut(j.url) }); }
              else if (j.status > 2) { AI_NAPLOZVA[a[1]] = 1; kuld({ t: 'gen_err', u: a[1], f: null, x: { s: j.status, ai: 1 } }); }
            }).catch(function () { /* nem JSON */ });
          } catch (e) { /* nem baj */ }
        }, function () { /* hálózati hiba: az oldal újrapróbál, nem naplózunk */ });
      } else if (KOSAR.test(cim)) {
        ig.then(function (v) {
          try {
            if (!v.ok) return;
            v.clone().json().then(function (j) {
              var tetelek = (j && j.items) ? j.items : (j ? [j] : []);
              tetelek.forEach(function (t) {
                var p = t && t.properties;
                if (!p || !p._customization_id) return;
                var kep = null;
                Object.keys(p).forEach(function (k) {
                  var m = /customers\/uploads\/([\w\-]+)/.exec(String(p[k]));
                  if (m && !kep) kep = 'customers/uploads/' + m[1];
                });
                kuld({ t: 'kosar', h: t.handle || termek(), cu: String(p._customization_id), r: kep });
              });
            }).catch(function () { /* nem JSON */ });
          } catch (e) { /* nem baj */ }
        }, function () { /* a kosár hibáját a bolt kezeli */ });
      }
    } catch (e) { /* a hívás eredménye érintetlen marad */ }
    return ig;
  };
})();
